"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const SyncAlt_1 = __importDefault(require("@material-ui/icons/SyncAlt"));
const TextField_1 = __importDefault(require("@material-ui/core/TextField"));
const makeStyles_1 = __importDefault(require("@material-ui/styles/makeStyles"));
const getCurrentUser_1 = __importDefault(require("../../actions/users/getCurrentUser"));
const cycles_1 = require("../../formatters/cycles");
const cycleFunctions = __importStar(require("../../utils/cycleFunctions"));
const useStyles = makeStyles_1.default((theme) => ({
    container: {
        padding: "10px 10px 0 10px"
    },
    box: {
        padding: 10,
        display: "inline-block",
        backgroundColor: theme.colors.textBox.backgroundColor,
        borderRadius: 6
    },
    inputContainer: {
        display: "flex",
        marginTop: 10,
        alignItems: "center"
    },
    input: {
        width: 170,
        backgroundColor: theme.colors.textBox.backgroundColor,
    },
    cyclesInput: {
        marginRight: 10,
    },
    poundsInput: {
        marginLeft: 10,
    },
    balanceContainer: {
        display: "flex",
        justifyContent: "space-between",
        marginTop: 4,
        marginBottom: 8,
        "& a": {
            marginLeft: 30
        }
    }
}));
const SendCycles = react_1.forwardRef((props, ref) => {
    const dispatch = react_redux_1.useDispatch();
    const [cycles, setCycles] = react_1.useState("");
    const [dollars, setDollars] = react_1.useState("");
    const [balance, setBalance] = react_1.useState("...");
    const classes = useStyles();
    react_1.useEffect(() => {
        fetchCurrentBalance();
    }, []);
    react_1.useImperativeHandle(ref, () => ({ getCycles }));
    function getCycles() {
        return cycleFunctions.fromT(parseFloat(cycles));
    }
    function onCyclesChanged(text) {
        setCycles(text);
        const dollars = text.length > 0
            ? cycleFunctions.round(cycleFunctions.toCurrency(cycleFunctions.fromT(parseFloat(text)), "USD")).toString()
            : "";
        setDollars(dollars);
    }
    function onDollarsChanged(text) {
        setDollars(text);
        const cycles = text.length > 0
            ? cycleFunctions.round(cycleFunctions.toT(cycleFunctions.fromCurrency(parseFloat(text), "USD"))).toString()
            : "";
        setCycles(cycles);
    }
    function fetchCurrentBalance() {
        const getCurrentUserAsync = () => dispatch(getCurrentUser_1.default());
        getCurrentUserAsync().then((outcome) => {
            if (outcome.type === "GET_CURRENT_USER_SUCCEEDED") {
                setBalance(cycles_1.formatCycles(outcome.payload.accountBalance));
            }
        });
    }
    return (react_1.default.createElement("div", { className: classes.container },
        react_1.default.createElement("div", { className: classes.box },
            react_1.default.createElement(Typography_1.default, { component: "div", variant: "h6" },
                "Send cycles to ",
                props.recipient.username),
            react_1.default.createElement("div", { className: classes.balanceContainer },
                react_1.default.createElement(Typography_1.default, { component: "div", variant: "caption" },
                    "Current balance ",
                    react_1.default.createElement("strong", null, balance))),
            react_1.default.createElement("div", { className: classes.inputContainer },
                react_1.default.createElement(TextField_1.default, { id: "cyclesInput", label: "Cycles (T)", type: "number", value: cycles, className: classes.cyclesInput + " " + classes.input, onChange: e => onCyclesChanged(e.target.value) }),
                react_1.default.createElement(SyncAlt_1.default, null),
                react_1.default.createElement(TextField_1.default, { id: "poundsInput", label: "USD", type: "number", value: dollars, className: classes.poundsInput + " " + classes.input, onChange: e => onDollarsChanged(e.target.value) })))));
});
exports.default = react_1.default.memo(SendCycles);
